import Vue from "vue";
import VueRouter from "vue-router";
import { i18n } from "@/locales/locale";
Vue.use(VueRouter);

// Update this each year to match the current active event
const CURRENT_WEEK = "week2026";

const routes = [
  // No locale → redirect to default locale (zh-hant)
  {
    path: "/nationalreadingcampaignweek:year(\\d{4})?",
    redirect: (to) => {
      const year = to.params.year || "";
      return `/nationalreadingcampaignweek${year}/zh-hant`;
    },
  },
  {
    path:
      "/nationalreadingcampaignweek:year(\\d{4})?/:locale(zh-hant|zh-hans|en|pt)",
    name: "main-layout",
    component: () => import("../views/Layout.vue"),
    children: [
      {
        path: "/",
        name: "home",
        component: () => import("../views/Home.vue"),
      },
      {
        path: "activeList",
        name: "activeList",
        component: () => import("../views/ActiveList.vue"),
        meta: {
          pageTitle: "活動資訊",
          nav: true,
          keepAlive: true,
        },
      },
      // {
      //   path: "active/event-club",
      //   name: "nationalreading-event-club",
      //   component: () => import("../views/slug.vue"),
      //   meta: {
      //     pageTitle: "讀書會",
      //     keepAlive: false,
      //     nav: true,
      //   },
      // },
      // {
      //   path: "active/event-room",
      //   name: "nationalreading-event-room",
      //   component: () => import("../views/slug.vue"),
      //   meta: {
      //     pageTitle: "室內活動",
      //     keepAlive: false,
      //     nav: true,
      //   },
      // },
      // {
      //   path: "active/event-ground",
      //   name: "nationalreading-event-ground",
      //   component: () => import("../views/slug.vue"),
      //   meta: {
      //     pageTitle: "戶外廣場活動",
      //     keepAlive: false,
      //     nav: true,
      //   },
      // },
      // {
      //   path: "active/event-ground-show",
      //   name: "nationalreading-event-ground-show",
      //   component: () => import("../views/slug.vue"),
      //   meta: {
      //     pageTitle: "戶外廣場舞台節目",
      //     keepAlive: false,
      //     nav: true,
      //   },
      // },
      // {
      //   path: "active/event-preheat",
      //   name: "nationalreading-event-preheat",
      //   component: () => import("../views/slug.vue"),
      //   meta: {
      //     pageTitle: "預熱活動",
      //     keepAlive: false,
      //     nav: true,
      //   },
      // },
      // {
      //   path: "active/event-launch",
      //   name: "nationalreading-event-launch",
      //   component: () => import("../views/slug.vue"),
      //   meta: {
      //     pageTitle: "啟動儀式",
      //     keepAlive: false,
      //     nav: true,
      //   },
      // },
      // {
      //   path: "active/event-lecture",
      //   name: "nationalreading-event-lecture",
      //   component: () => import("../views/slug.vue"),
      //   meta: {
      //     pageTitle: "專題講座",
      //     keepAlive: false,
      //     nav: true,
      //   },
      // },
      // {
      //   path: "active/event-library-week",
      //   name: "nationalreading-event-library-week",
      //   component: () => import("../views/slug.vue"),
      //   meta: {
      //     pageTitle: "澳門圖書館周",
      //     keepAlive: false,
      //     nav: true,
      //   },
      // },
      // {
      //   path: "active/event-extra",
      //   name: "nationalreading-event-extra",
      //   component: () => import("../views/slug.vue"),
      //   meta: {
      //     pageTitle: "延伸活動",
      //     keepAlive: false,
      //     nav: true,
      //   },
      // },
      // {
      //   path: "active/event-monthly-reading",
      //   name: "nationalreading-event-monthly-reading",
      //   component: () => import("../views/slug.vue"),
      //   meta: {
      //     pageTitle: "其他活動",
      //     keepAlive: false,
      //     nav: true,
      //   },
      // },
      // {
      //   path: "active/10-min_reading",
      //   name: "nationalreading-10-min_reading",
      //   component: () => import("../views/slug.vue"),
      //   meta: {
      //     pageTitle: "閱讀10分鐘",
      //     keepAlive: false,
      //     nav: true,
      //   },
      // },
      // {
      //   path: "active/:slug",
      //   name: "event-slug",
      //   component: () => import("../views/slug.vue"),
      //   meta: {
      //     pageTitle: "活動資訊",
      //     keepAlive: false,
      //     nav: true,
      //   },
      // },
      {
        path: "media",
        name: "media",
        component: () => import("../views/Media.vue"),
        meta: {
          pageTitle: "媒體發佈",
          nav: true,
        },
      },
      {
        path: "read",
        name: "read",
        component: () => import("../views/Read.vue"),
        meta: {
          pageTitle: "共讀點",
          keepAlive: true,
          nav: true,
        },
      },
      {
        path: "read-detail",
        name: "read-detail",
        component: () => import("../views/ReadDetail.vue"),
        meta: {
          pageTitle: "共讀點",
          nav: true,
          parent: "全城共讀",
        },
      },
      {
        path: "contact",
        name: "contact",
        component: () => import("../views/contact.vue"),
        meta: {
          pageTitle: "聯絡我們",
          nav: true,
        },
      },
      // 404 路由移到 addDynamicRoutes 中动态添加
    ],
  },
  {
    path: "/:locale(zh-hant|zh-hans|en|pt)/topic",
    component: () => import("../topicViews/Layout.vue"),
    children: [
      {
        path: ":week(week\\d{4})",
        name: "topic-home",
        component: () => import("../topicViews/Home.vue"),
      },
      {
        path: ":week(week\\d{4})/active",
        name: "topic-active",
        component: () => import("../topicViews/Active.vue"),
        meta: {
          pageTitle: "活動資訊",
          nav: true,
        },
      },
      {
        path: ":week(week\\d{4})/activeList",
        name: "topic-activeList",
        component: () => import("../topicViews/ActiveList.vue"),
        meta: {
          pageTitle: "活動資訊",
          nav: true,
          keepAlive: true,
        },
      },
      {
        path: ":week(week\\d{4})/active/preheat",
        name: "topic-event-preheat",
        component: () => import("../topicViews/ActivePreheat.vue"),
        meta: {
          pageTitle: "預熱活動",
          keepAlive: true,
          nav: true,
        },
      },
      {
        path: ":week(week\\d{4})/active/launch",
        name: "topic-event-launch",
        component: () => import("../topicViews/ActiveLaunch.vue"),
        meta: {
          pageTitle: "澳門全城共讀月-啟動儀式",
          keepAlive: true,
          nav: true,
        },
      },
      {
        path: ":week(week\\d{4})/active/library-week",
        name: "topic-event-library-week",
        component: () => import("../topicViews/ActiveLibraryWeek.vue"),
        meta: {
          pageTitle: "澳門圖書館周",
          keepAlive: true,
          nav: true,
        },
      },
      {
        path: ":week(week\\d{4})/active/monthly-reading",
        name: "topic-event-monthly-reading",
        component: () => import("../topicViews/ActiveMonthlyReading.vue"),
        meta: {
          pageTitle: "其他活動",
          keepAlive: true,
          nav: true,
        },
      },
      {
        path: ":week(week\\d{4})/active/lecture",
        name: "topic-event-lecture",
        component: () => import("../topicViews/ActiveLecture.vue"),
        meta: {
          pageTitle: "專題講座",
          keepAlive: true,
          nav: true,
        },
      },
      {
        path: ":week(week\\d{4})/active/room",
        name: "topic-event-room",
        component: () => import("../topicViews/ActiveRoom.vue"),
        meta: {
          pageTitle: "室內活動",
          keepAlive: true,
          nav: true,
        },
      },
      {
        path: ":week(week\\d{4})/active/club",
        name: "topic-event-club",
        component: () => import("../topicViews/ActiveClub.vue"),
        meta: {
          pageTitle: "讀書會",
          keepAlive: true,
          nav: true,
        },
      },
      {
        path: ":week(week\\d{4})/active/ground",
        name: "topic-event-ground",
        component: () => import("../topicViews/ActiveGround.vue"),
        meta: {
          pageTitle: "戶外廣場活動",
          keepAlive: true,
          nav: true,
        },
      },
      {
        path: ":week(week\\d{4})/active/ground-show",
        name: "topic-event-ground-show",
        component: () => import("../topicViews/ActiveGroundShow.vue"),
        meta: {
          pageTitle: "戶外廣場舞台節目",
          keepAlive: true,
          nav: true,
        },
      },
      {
        path: ":week(week\\d{4})/media",
        name: "topic-media",
        component: () => import("../topicViews/Media.vue"),
        meta: {
          pageTitle: "媒體發佈",
          nav: true,
        },
      },
      {
        path: ":week(week\\d{4})/read",
        name: "topic-read",
        component: () => import("../topicViews/Read.vue"),
        meta: {
          pageTitle: "共讀點",
          keepAlive: true,
          nav: true,
        },
      },
      {
        path: ":week(week\\d{4})/read-detail",
        name: "topic-read-detail",
        component: () => import("../topicViews/ReadDetail.vue"),
        meta: {
          pageTitle: "共讀點",
          nav: true,
          parent: "全城共讀",
        },
      },
      {
        path: ":week(week\\d{4})/contact",
        name: "topic-contact",
        component: () => import("../topicViews/contact.vue"),
        meta: {
          pageTitle: "聯絡我們",
          nav: true,
        },
      },
      {
        path: "*",
        component: () => import("../topicViews/404.vue"),
        name: "topic-404",
        meta: {
          pageTitle: "頁面未找到",
        },
      },
    ],
  },
  {
    path: "/",
    redirect: "/nationalreadingcampaignweek",
  },
];

function createRouter(routesConfig = routes) {
  return new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes: routesConfig,
    scrollBehavior(to, from, savedPosition) {
      return new Promise((resolve) => {
        setTimeout(() => {
          if (to.hash) {
            resolve({
              selector: to.hash,
              behavior: "smooth",
            });
          } else if (savedPosition) {
            resolve({
              x: savedPosition.x,
              y: savedPosition.y,
            });
          } else {
            resolve({
              x: 0,
              y: 0,
            });
          }
        }, 300);
      });
    },
  });
}

function getRoutesWithoutStaticRead() {
  return routes.map((route) => {
    if (route.name !== "main-layout" || !Array.isArray(route.children)) {
      return route;
    }

    return {
      ...route,
      children: route.children.filter((child) => child.name !== "read"),
    };
  });
}

function resetRouter(removeStaticRead = false) {
  const nextRouter = createRouter(
    removeStaticRead ? getRoutesWithoutStaticRead() : routes,
  );
  router.matcher = nextRouter.matcher;
}

const router = createRouter();

// 标记动态路由是否已加载
let dynamicRoutesLoaded = false;
let loadDynamicRoutesPromise = null;

async function ensureDynamicRoutes() {
  if (dynamicRoutesLoaded) return true;

  if (!loadDynamicRoutesPromise) {
    loadDynamicRoutesPromise = (async () => {
      try {
        const { fetchTopic } = await import("@/api/base");
        const { data } = await fetchTopic({ slug: "week2026" });
        if (data.menu && data.menu["main-menu"]) {
          addDynamicRoutes(data.menu["main-menu"]);
        }
        dynamicRoutesLoaded = true;
        return true;
      } catch (error) {
        console.warn("Failed to load dynamic routes:", error);
        return false;
      }
    })();
  }

  return loadDynamicRoutesPromise;
}

// 设置动态路由已加载
function setDynamicRoutesLoaded(loaded) {
  dynamicRoutesLoaded = loaded;
}

router.beforeEach(async (to, from, next) => {
  // 检查是否可能是动态路由（路径符合动态路由模式但还没加载动态路由）
  const isPotentialDynamicRoute =
    !dynamicRoutesLoaded &&
    /^\/nationalreadingcampaignweek\d*\/(zh-hant|zh-hans|en|pt)\/(active\/|read$)/.test(
      to.path,
    );

  if (isPotentialDynamicRoute) {
    await ensureDynamicRoutes();
    // 重新导航
    next({ path: to.path, replace: true });
    return;
  }

  const locale = to.params.locale || "zh-hant";
  i18n.locale = locale;

  // Derive week from year param
  const year = to.params.year;
  to.meta.week = year ? `week${year}` : CURRENT_WEEK;

  if (to.name != "home") {
    document.title = i18n.t(to.meta.pageTitle);
  }
  next();
});

/**
 * 递归提取所有 useVue 为 true 的菜单项
 * @param {Array} menuData - 菜单数组
 * @param {Array} result - 结果数组
 */
function extractVueRoutes(menuData, result = []) {
  if (!Array.isArray(menuData)) return result;

  menuData.forEach((item) => {
    // 如果 useVue 为 true，添加到结果
    if (item.useVue && item.path) {
      result.push(item);
    }
    // 递归处理 submenu
    if (Array.isArray(item.submenu) && item.submenu.length > 0) {
      extractVueRoutes(item.submenu, result);
    }
  });

  return result;
}

/**
 * 根据后台菜单数据动态添加路由
 * @param {Array} menuData - 后台返回的菜单数组 (如 data.menu['main-menu'])
 */
export function addDynamicRoutes(menuData) {
  if (!Array.isArray(menuData)) {
    console.warn("addDynamicRoutes: menuData 必须是数组");
    return [];
  }

  // 递归提取所有需要生成路由的菜单项
  const vueItems = extractVueRoutes(menuData);
  const hasRead2026Route = vueItems.some(
    (item) => item.path === "read" && item.vueType === "week2026",
  );

  if (hasRead2026Route) {
    resetRouter(true);
  }

  const dynamicRoutes = vueItems.map((item) => {
    const isRead2026Route = item.path === "read" && item.vueType === "week2026";
    const component =
      isRead2026Route
        ? () => import("../views/Read2026.vue")
        : () => import("../views/slug.vue");

    // 如果 path 已包含 /，直接使用；否则添加 active/ 前缀
    const routePath = isRead2026Route || item.path.includes("/")
      ? item.path
      : `active/${item.path}`;

    return {
      path: routePath,
      name: item.path,
      // 注意：import 路径必须是静态字符串，不能使用变量
      component,
      meta: {
        pageTitle: item.label,
        slug: item.catSlug || item.slug || null,
        vueType: item.vueType || null,
        keepAlive: item.keepAlive !== undefined ? item.keepAlive : false,
        nav: item.nav !== undefined ? item.nav : true,
      },
    };
  });
  console.log("动态生成的路由:", dynamicRoutes);
  // 添加到 main-layout 父路由下
  dynamicRoutes.forEach((route) => {
    router.addRoute("main-layout", route);
  });

  // 添加 404 路由到末尾（确保动态路由优先匹配）
  router.addRoute("main-layout", {
    path: "*",
    component: () => import("../views/404.vue"),
    name: "404",
    meta: {
      pageTitle: "頁面未找到",
    },
  });

  console.log("当前路由列表:", router.getRoutes());
  return dynamicRoutes;
}

export { CURRENT_WEEK, setDynamicRoutesLoaded };
export default router;
